import { subscriptionSchema } from "@/utils/validation/subscriptionSchema";
import { yupResolver } from "@hookform/resolvers/yup";
import { Resolver, ValidationMode } from "react-hook-form";

export const formConfig = {
  resolver: yupResolver(subscriptionSchema) as Resolver<ISubscriptionFields>,
  mode: "all" as keyof ValidationMode,
  defaultValues: { email: "" },
};
